import PageWrapper from "../../components/common/layout/PageWrapper";
import { useTranslation } from "react-i18next";
import useAppSelector from "../../../hooks/redux/base/useAppSelector";
import LibservAdditionalDocEdit from "../../components/services/additionalDoc/LibservAdditionalDocEdit";

const LibservAdditionalDocEditPage = () => {
  const { t } = useTranslation();

  const selectedService = useAppSelector((state) => {
    return state.SelectedService;
  });

  return (
    <PageWrapper title={t(`${selectedService.titleCode}.edit`)}>
      <LibservAdditionalDocEdit />
    </PageWrapper>
  );
};

export default LibservAdditionalDocEditPage;
